module.exports = __webpack_public_path__ + "static/media/monsterGalaxy.d6afe227.jpg";